import { render, staticRenderFns } from "./JudgeWrapNode.vue?vue&type=template&id=020d3c43&scoped=true&"
import script from "./JudgeWrapNode.vue?vue&type=script&lang=js&"
export * from "./JudgeWrapNode.vue?vue&type=script&lang=js&"
import style0 from "./JudgeWrapNode.vue?vue&type=style&index=0&id=020d3c43&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d3c43",
  null
  
)

export default component.exports